
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("jbr6J"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("jbr6J", function(module, exports) {

let $df741261141cf162$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $df741261141cf162$var$load("dIzOY"),
    $df741261141cf162$var$load("alXrq"),
    $df741261141cf162$var$load("2YffH"),
    $df741261141cf162$var$load("iDB1L"),
    $df741261141cf162$var$load("1aTst"),
    $df741261141cf162$var$load("eEyVs"),
    $df741261141cf162$var$load("6mHrv"),
    $df741261141cf162$var$load("awWN9"),
    $df741261141cf162$var$load("9CYct"),
    $df741261141cf162$var$load("iIoyG"),
    $df741261141cf162$var$load("2xn4F"),
    $df741261141cf162$var$load("hZtKG"),
    $df741261141cf162$var$load("iNmaF"),
    $df741261141cf162$var$load("lVO3w"),
    $df741261141cf162$var$load("hyzoX"),
    $df741261141cf162$var$load("h9Ed7"),
    $df741261141cf162$var$load("eBRUf"),
    $df741261141cf162$var$load("bogQM"),
    $df741261141cf162$var$load("jq3Ai"),
    $df741261141cf162$var$load("bv7z8"),
    $df741261141cf162$var$load("8A3nE"),
    $df741261141cf162$var$load("8YSo7"),
    $df741261141cf162$var$load("g7ggm"),
    $df741261141cf162$var$load("9S9Mz"),
    $df741261141cf162$var$load("kiGNy"),
    $df741261141cf162$var$load("7do1E"),
    $df741261141cf162$var$load("77dkW"),
    $df741261141cf162$var$load("arCL2"),
    $df741261141cf162$var$load("g9CVe"),
    $df741261141cf162$var$load("6iz6l"),
    $df741261141cf162$var$load("4SCW2"),
    $df741261141cf162$var$load("855o0"),
    $df741261141cf162$var$load("8MfZE"),
    $df741261141cf162$var$load("hv4mn"),
    $df741261141cf162$var$load("dek7I"),
    $df741261141cf162$var$load("3SmkN"),
    $df741261141cf162$var$load("dYtBN"),
    $df741261141cf162$var$load("kNV5Y"),
    $df741261141cf162$var$load("6wr18"),
    $df741261141cf162$var$load("kjZZD"),
    $df741261141cf162$var$load("bkc7o"),
    $df741261141cf162$var$load("2wlUS"),
    $df741261141cf162$var$load("9u7sS"),
    $df741261141cf162$var$load("1fem1"),
    $df741261141cf162$var$load("Wowvf"),
    $df741261141cf162$var$load("ffEVr"),
    $df741261141cf162$var$load("hhss7"),
    $df741261141cf162$var$load("dTsOE"),
    $df741261141cf162$var$load("kquhK"),
    $df741261141cf162$var$load("drtqM"),
    $df741261141cf162$var$load("henq4"),
    $df741261141cf162$var$load("k5Ch2"),
    $df741261141cf162$var$load("djob1"),
    $df741261141cf162$var$load("8fMw3"),
    $df741261141cf162$var$load("hogcU"),
    $df741261141cf162$var$load("dAdaw"),
    $df741261141cf162$var$load("h3ABO"),
    $df741261141cf162$var$load("kC80R"),
    $df741261141cf162$var$load("7EorR"),
    $df741261141cf162$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.f2226dd2.js.map
